module.exports = __webpack_public_path__ + "img/logo.116b4554.png";